import React from "react";
import "../../CSS/signup/signupSideDescription.modules.css";

export const SignupSideDescription = () => {
  return (
    <div id="signupSideDescription">
      <p id="signupSideDescriptionQuote">"</p>

      <div id="signupSideDescriptionDetails">
        <p>
          Toggl Track has a very straightforward interface. It's easy to start,
          stop and edit time entries and to review your own work and the work of
          colleagues.
        </p>

        <p>
          It just works, even in a team where some members find new interfaces
          challenging.
        </p>

        <p>— Verified G2Crowd review. 5/5 stars.</p>
      </div>
    </div>
  );
};
